import Auth from '../../../../../auth';
import _ from 'lodash';
export default function AlertsCreateController(
  $scope,
  $rootScope,
  $state,
  $filter,
  $uibModal,
  configurationsService,
  gettextCatalog,
  ConfigurationFilterService
) {
  'ngInject';

  //Local Variables
  const currentUser = $rootScope.currentUser;
  //Changed to use ES6 variables
  const orderBy = $filter('orderBy');

  //Public Variables
  $scope.contactsList = [];
  $scope.configurationId = {};
  $scope.dataPointDescriptors = _.cloneDeep($rootScope.datapointDescriptors);
  $scope.descriptorVisible = false;
  $scope.disableCancel = false;
  $scope.duplicateConditionText = gettextCatalog.getString(
    'When creating multiple triggers while using the same data point, the condition must be unique. Please change the condition and try again.'
  );
  $scope.editMode = true;
  $scope.equipmentData = [];
  $scope.errorFlag = false;
  $scope.errorText = '';
  $scope.eventPropertyName = 'description'; //sort datapoint dropdown
  $scope.hasTriggers = true;
  $scope.incompleteTriggerFlag = false;
  $scope.incompleteTriggerMsg = gettextCatalog.getString(
    'Please save or cancel the trigger before trying to create a configuration'
  );
  $scope.noTriggersSavedMsg = gettextCatalog.getString(
    'Please create at least one trigger before creating a configuration.'
  );
  $scope.param = {};
  $scope.savedTriggers = [];
  $scope.selectedEquipment = {};
  $scope.sortedEvents = [];

  $scope.thresholdOptions = [];
  $scope.triggers = [];
  $scope.validationFlag = false;
  $scope.validationMsg = gettextCatalog.getString('All fields are required');
  $scope.showKMLabel = false;
  $scope.alertConfigDataPoint = {
    helpMe: 'alertConfigDataPoint'
  };
  $scope.alertConfigCondition = {
    helpMe: 'alertConfigCondition'
  };
  $scope.alertConfigDelay = {
    helpMe: 'alertConfigDelay'
  };
  $scope.alertConfigPriority = {
    helpMe: 'alertConfigPriority'
  };
  $scope.alertConfigAutoClear = {
    helpMe: 'alertConfigAutoClear'
  };
  $scope.alertConfigNotifyOnReturn = {
    helpMe: 'alertConfigNotifyOnReturn'
  };

  //public methods
  $scope.addTrigger = addTrigger;
  init();

  function init() {
    filterDefaultDataPointDescriptors($scope.dataPointDescriptors);
    getDatapoints();
    addTrigger(); //Add a row to the trigger table on page load

    //replace default tool tip icons with the light versions
    let triggerIcons = document.getElementsByClassName('fa-info-circle');
    Array.from(triggerIcons).forEach(function (icon) {
      icon.classList.add('far');
      icon.classList.remove('fa');
    });
  }

  //function to turn the editableselect into a searchable dropdown
  //.25 of a second timeout because the page finishes loading before the editableselect gets added to the page
  $scope.initSelect2 = function () {
    setTimeout(function () {
      $('#data-point').select2();
    }, 250);
  };

  // Function to filter all datapointDescriptors that have a default on them. Default to an empty array(in test $scope.datapointDescriptor is undefined)
  function filterDefaultDataPointDescriptors(descriptors = []) {
    descriptors.forEach(descriptor => {
      if (descriptor.values.hasOwnProperty('default')) {
        delete descriptor.values['default'];
      }
    });
  }
  //Dropdown menu Models
  $scope.priorityOptions = [
    {
      value: 'Low',
      label: gettextCatalog.getString('Low')
    },
    {
      value: 'Medium',
      label: gettextCatalog.getString('Medium')
    },
    {
      value: 'High',
      label: gettextCatalog.getString('High')
    }
  ];
  //for UI
  $scope.relationalSymbolsOptions = [
    {
      value: '<',
      label: '<',
      description: gettextCatalog.getString('Less Than')
    },
    {
      value: '<=',
      label: '<=',
      description: gettextCatalog.getString('Less Than or Equal to')
    },
    {
      value: '>',
      label: '>',
      description: gettextCatalog.getString('Greater Than')
    },
    {
      value: '>=',
      label: '>=',
      description: gettextCatalog.getString('Greater Than or equal to')
    },
    {
      value: '==',
      label: '=',
      description: gettextCatalog.getString('Equal to')
    },
    {
      value: '!=',
      label: '!=',
      description: gettextCatalog.getString('Not Equal to')
    }
  ];
  //for validation and building triggers to submit
  const relationalSymbols = [
    {
      value: '<',
      label: '<',
      description: gettextCatalog.getString('Less Than')
    },
    {
      value: '<=',
      label: '<=',
      description: gettextCatalog.getString('Less Than or Equal to')
    },
    {
      value: '>',
      label: '>',
      description: gettextCatalog.getString('Greater Than')
    },
    {
      value: '>=',
      label: '>=',
      description: gettextCatalog.getString('Greater Than or equal to')
    },
    {
      value: '==',
      label: '=',
      description: gettextCatalog.getString('Equal to')
    },
    {
      value: '!=',
      label: '!=',
      description: gettextCatalog.getString('Not Equal to')
    }
  ];

  $scope.unitOfTimeOptions = [
    {
      value: 'seconds',
      label: gettextCatalog.getString('Second(s)')
    },
    {
      value: 'minutes',
      label: gettextCatalog.getString('Minute(s)')
    },
    {
      value: 'hours',
      label: gettextCatalog.getString('Hour(s)')
    }
  ];

  $scope.clearOptions = [
    {
      value: '1',
      label: gettextCatalog.getString('Immediately')
    },
    {
      value: '2',
      label: gettextCatalog.getString('After 24hrs')
    }
  ];

  $scope.notifyOnReturnOptions = [
    {
      value: true,
      label: gettextCatalog.getString('Yes')
    },
    {
      value: false,
      label: gettextCatalog.getString('No')
    }
  ];

  $scope.$on('totalEmails', function (event, totalEmails) {
    $scope.maxEmails = totalEmails.length;
  });

  //called when trigger form is open
  $scope.disableEditButton = function () {
    //enables edit and delete buttons
    $scope.editMode = true;
  };

  //called when trigger from is closed
  $scope.enableEditButton = function () {
    //disables edit and delete buttons
    $scope.editMode = false;
  };
  //get list of datapoints to display in UI.
  function getDatapoints() {
    // Creating placeholder for the datapoints and dapapoints descriptors
    const copyVisibleDataPoints = _.cloneDeep(currentUser.visibleDatapoints);
    const dataPointDescriptors = $scope.datapointDescriptors;

    let events = copyVisibleDataPoints.map(visibleDataPoint => {
      let foundDpdesc = dataPointDescriptors.find(dpdesc => dpdesc.key === visibleDataPoint.id);
      // Assign the value of visibleDatapoint.descriptor if a match is found. Else keep the original value
      visibleDataPoint.description =
        foundDpdesc && foundDpdesc.title ? foundDpdesc.title : visibleDataPoint.description;

      if (foundDpdesc !== undefined) {
        if (foundDpdesc.hasOwnProperty('values')) {
          visibleDataPoint.state = 'States';
        } else {
          visibleDataPoint.state = 'Values';
        }
      } else {
        visibleDataPoint.state = 'Values';
      }

      return visibleDataPoint;
    });
    events = ConfigurationFilterService.filterInvalidDatapoints(events);

    //filter out the states and values into their own separate arrays to make alphatical sorting easier
    let statesArray = events.filter(a => a.state === 'States');
    let valuesArray = events.filter(a => a.state === 'Values');

    statesArray = orderBy(statesArray, $scope.eventPropertyName);
    valuesArray = orderBy(valuesArray, $scope.eventPropertyName);

    let combinedArrays = statesArray.concat(valuesArray);

    $scope.sortedEvents = combinedArrays;
  }

  //Trigger Form Validation - Checks the values of each editable control before submitting the form.
  $scope.checkIfString = function (data) {
    if (data === '' || data === null) {
      $scope.validationFlag = true;
      return gettextCatalog.getString('required');
    }
  };

  $scope.checkNumericalValue = function (data) {
    if (isNaN(data)) {
      return gettextCatalog.getString('invalid number');
    } else {
      return $scope.checkIfString(data);
    }
  };

  //Validate the duration input before saving the trigger model to make sure we have not exceeded 24hrs
  //Need to disable the cancel button to force the user to change the duration
  $scope.checkDurationValue = function (data, triggerForm) {
    const maxTime = {
      hours: 24,
      minutes: 1440,
      seconds: 86200
    };
    const max = maxTime[triggerForm.$data?.unitOfTime?.value];
    if (isNaN(data)) {
      return gettextCatalog.getString('invalid number');
    } else if (data > max) {
      $scope.disableCancel = true;
      return gettextCatalog.getString('max limit ' + max);
    } else {
      $scope.disableCancel = false;
      return $scope.checkIfString(data);
    }
  };

  //Adds a new row to the triggers table
  function addTrigger() {
    $scope.trigger = {
      id: $scope.triggers.length,
      datapoint: '',
      condition: {
        relationalOperator: '',
        thresholdValue: '',
        duration: '',
        unitOfTime: ''
      },
      priority: '',
      autoClear: '',
      notifyOnReturn: ''
    };
    $scope.triggers.push($scope.trigger);
    $scope.isDisabled = true;
    $scope.descriptorVisible = false;
  }

  //Before saving a new trigger we want to check the triggers[] to prevent saving duplicate trigger conditons for the same event
  $scope.saveTrigger = function (data, index, id) {
    $scope.validationFlag = false;
    $scope.incompleteTriggerFlag = false;

    //Flag to hide or show duplicate condition message
    $scope.duplicateEventCondition = false;

    //Triggers to be saved with configuration
    const savedTrigger = {
      id: id,
      datapoint: data.datapoint,
      condition: {
        relationalOperator: data.relationalOperator,
        thresholdValue: data.thresholdValue,
        duration: data.duration,
        unitOfTime: data.unitOfTime
      },
      priority: data.priority,
      autoClear: data.autoClear,
      notifyOnReturn: data.notifyOnReturn
    };

    //remove duplicate trigger from savedTriggers array
    for (let i = 0; i < $scope.savedTriggers.length; i++) {
      if (id === $scope.savedTriggers[i].id) {
        $scope.savedTriggers.splice(index, 1);
      }
    }

    //validate the datapoint and condition
    if ($scope.savedTriggers.length >= 1) {
      for (let i = 0; i < $scope.savedTriggers.length; i++) {
        let savedTriggerCondition = $scope.savedTriggers[i].condition;
        if (
          data.datapoint.id === $scope.savedTriggers[i].datapoint.id &&
          data.relationalOperator.value === savedTriggerCondition.relationalOperator.value &&
          data.thresholdValue === savedTriggerCondition.thresholdValue &&
          data.duration === savedTriggerCondition.duration &&
          data.unitOfTime.value === savedTriggerCondition.unitOfTime.value
        ) {
          $scope.duplicateEventCondition = true;
          return 'Duplicate Condition';
        }
      }
    }

    if ($scope.duplicateEventCondition === false) {
      //push savedTrigger model
      $scope.savedTriggers.push(savedTrigger);
      //reset trigger model
      $scope.trigger = {};
      //enable add trigger button
      $scope.isDisabled = false;
      $scope.hasTriggers = true;
    }
  };

  //removes triggers from both contains
  $scope.removeTrigger = function (index) {
    $scope.triggers.splice(index, 1);
    $scope.savedTriggers.splice(index, 1);
  };

  //remove trigger before saved if cancel button is clicked
  $scope.cancelTrigger = function (index) {
    if ($scope.triggers.length > $scope.savedTriggers.length) {
      $scope.triggers.splice(index, 1);
    }
  };

  //display the number of assets selected from the picker
  $scope.numSelectedAssets = function () {
    if (!$scope.param._selected || !$scope.param) return 0;

    return Object.keys($scope.param._selected).length;
  };

  //Select Asset Modal
  $scope.selectAssetsButtonPressed = function () {
    let modalInstance = $uibModal.open({
      animation: true,
      template: require('../../../../../components/assetpicker/asset.multi.picker.html'),
      controller: 'AssetMultiPickerController',
      size: 'lg',
      resolve: {
        singleSelect: false,
        requiresSelection: true,
        maxSelection: function () {
          return 0;
        },
        selectedAssets: function () {
          let selected = {};

          if ($scope.equipmentData) {
            for (let i = 0; i < $scope.equipmentData.length; i++) {
              let e = $scope.equipmentData[i];
              selected[e.id] = e;
            }
          }
          return selected;
        }
      }
    });

    modalInstance.result.then(
      function (selectedAssets) {
        $scope.equipmentData = [];
        for (let key in selectedAssets.result) {
          $scope.equipmentData.push(selectedAssets.result[key]);
        }
      },
      function () { }
    );
  };

  //filter through the list of datapointDescriptors using datapoint of selected row
  //or new row and display proper values for the condition dropdowns
  $scope.datapointSelected = function (data) {
    if (data) {
      let datapoint = data;
      $scope.showKMLabel = datapoint.description === 'Speed' ? true : false;
      $scope.thresholdOptions = [];
      for (let i = 0; i < $scope.dataPointDescriptors.length; i++) {
        if (datapoint.id === $scope.dataPointDescriptors[i].key) {
          for (let key in $scope.dataPointDescriptors[i].values) {
            let option = {
              value: parseInt(key),
              label: $scope.dataPointDescriptors[i].values[key]
            };
            $scope.thresholdOptions.push(option);
          }

          //Changes the dropdown options shown in the condition
          if ($scope.thresholdOptions && $scope.thresholdOptions.length !== 0) {
            $scope.descriptorVisible = true;
            $scope.relationalSymbolsOptions = [
              {
                value: '==',
                label: '=',
                description: gettextCatalog.getString('Equal to')
              },
              {
                value: '!=',
                label: '!=',
                description: gettextCatalog.getString('Not Equal to')
              }
            ];
          } else {
            $scope.descriptorVisible = false;
            $scope.relationalSymbolsOptions = relationalSymbols;
          }

          return;
        }
      }

      $scope.descriptorVisible = false;
      $scope.relationalSymbolsOptions = [
        {
          value: '<',
          label: '<',
          description: gettextCatalog.getString('Less Than')
        },
        {
          value: '<=',
          label: '<=',
          description: gettextCatalog.getString('Less Than or Equal to')
        },
        {
          value: '>',
          label: '>',
          description: gettextCatalog.getString('Greater Than')
        },
        {
          value: '>=',
          label: '>=',
          description: gettextCatalog.getString('Greater Than or equal to')
        },
        {
          value: '==',
          label: '=',
          description: gettextCatalog.getString('Equal to')
        },
        {
          value: '!=',
          label: '!=',
          description: gettextCatalog.getString('Not Equal to')
        }
      ];
    }
  };

  //Validate the form on submission then run the API call
  $scope.isFormValid = function (createConfigForm) {
    createConfigForm.$setSubmitted();
    if (createConfigForm.$invalid) {
      $scope.loading = false;
      return;
    }
    if ($scope.equipmentData.length === 0) {
      $scope.loading = false;
      return;
    }
    if ($scope.savedTriggers.length === 0) {
      $scope.loading = false;
      $scope.hasTriggers = false;
      return;
    }
    if ($scope.editMode === true) {
      $scope.incompleteTriggerFlag = true;
      return;
    } else {
      $scope.createConfiguration();
    }
  };

  $scope.configurationExists = function () {
    $scope.duplicateConfigName = false;
    configurationsService.getConfigurationByName($scope.configuration.name).then(function (response) {
      if (response.data.name === $scope.configuration.name) {
        $scope.duplicateConfigName = true;
      }
    }).catch(err => {
      if (404 != err.status)
        console.log(err)
    });
  }

  //Post Configuration
  $scope.createConfiguration = function () {
    $scope.loading = true;
    $scope.errorFlag = false;

    let configuration = {
      name: '',
      equipment: [],
      contacts: [],
      triggers: [],
      brand: ''
    };

    //get name
    configuration.name = $scope.configuration.name;

    const brand = Auth.getBrandClaim();
    if (brand != null) {
      configuration.brand = brand;
    }

    //get list of equipment ids
    if ($scope.equipmentData.length > 0) {
      for (let i = 0; i < $scope.equipmentData.length; i++) {
        configuration.equipment.push($scope.equipmentData[i].id);
      }
    }

    //get list of contacts
    for (let i = 0; i < $scope.contactsList.length; i++) {
      configuration.contacts.push($scope.contactsList[i].email);
    }

    //build the condition for each trigger in $scope.triggers
    let triggerScope = $scope.triggers;

    if (triggerScope && triggerScope.length > 0) {
      triggerScope.forEach(t => {
        let trigger = {
          datapoint: '',
          condition: ['IF', '[value]', '', '', 'FOR', '', ''],
          priority: '',
          autoClear: '',
          notifyOnReturn: ''
        };

        //trigger.datapoint
        for (let k = 0; k < currentUser.visibleDatapoints.length; k++) {
          if (t.datapoint.id === currentUser.visibleDatapoints[k].id) {
            trigger.datapoint = currentUser.visibleDatapoints[k].id;
          }
        }

        //trigger.condition[2]
        for (let j = 0; j < relationalSymbols.length; j++) {
          if (t.condition.relationalOperator.value === relationalSymbols[j].value) {
            trigger.condition[2] = relationalSymbols[j].value;
          }
        }

        //t.condition[3]
        if (isNaN(t.condition.thresholdValue)) {
          for (let p = 0; p < $scope.datapointDescriptors.length; p++) {
            if (t.datapoint.id === $scope.dataPointDescriptors[p].key) {
              for (let key in $scope.dataPointDescriptors[p].values) {
                if (t.condition.thresholdValue === $scope.dataPointDescriptors[p].values[key]) {
                  trigger.condition[3] = key;
                }
              }
            }
          }
        } else if (typeof t.condition.thresholdValue === 'number' && t.condition.thresholdValue % 1 === 0) {
          trigger.condition[3] = parseInt(t.condition.thresholdValue);
        } else {
          trigger.condition[3] = parseFloat(t.condition.thresholdValue);
        }

        //t.condtion[5]
        trigger.condition[5] = parseInt(t.condition.duration);

        //t.condition[6]
        for (let m = 0; m < $scope.unitOfTimeOptions.length; m++) {
          if (t.condition.unitOfTime.value === $scope.unitOfTimeOptions[m].value) {
            trigger.condition[6] = $scope.unitOfTimeOptions[m].value;
          }
        }

        let condition = trigger.condition.join(' ');

        //t.priority
        for (let m = 0; m < $scope.priorityOptions.length; m++) {
          if (t.priority.value === $scope.priorityOptions[m].value) {
            trigger.priority = $scope.priorityOptions[m].value;
          }
        }

        //t.autoClear
        if (t.autoClear.value === $scope.clearOptions[0].value) {
          trigger.autoClear = $scope.clearOptions[0].value;
        } else {
          trigger.autoClear = $scope.clearOptions[1].value;
        }

        //t.notify
        if (t.notifyOnReturn.value === $scope.notifyOnReturnOptions[0].value) {
          trigger.notifyOnReturn = $scope.notifyOnReturnOptions[0].value;
        } else {
          trigger.notifyOnReturn = $scope.notifyOnReturnOptions[1].value;
        }

        configuration.triggers.push({
          datapoint: trigger.datapoint,
          condition: condition,
          priority: trigger.priority,
          autoClear: trigger.autoClear,
          notifyOnReturn: trigger.notifyOnReturn
        });
      });
    }

    //Create Configuration
    configurationsService.postConfiguration(configuration).then(
      function (response) {
        $scope.loading = false;
        $state.go('alerts.configurations.edit', {
          configurationId: response.data.id
        });
      },
      function () {
        const errorMsg = gettextCatalog.getString('An error occurred while creating the Configuration');
        $scope.errorText = errorMsg;
        $scope.errorFlag = true;
        $scope.loading = false;
      }
    );
  }; //End createConfiguration
}
